import { identify, Identify, init, track, Types } from '@amplitude/analytics-browser'
import { isLocal, isProduction } from '../environment'

const amplitudeToken = process.env.NEXT_PUBLIC_AMPLITUDE_TOKEN
const isEnabled = !!amplitudeToken && isProduction
const isDebugEnabled = false

const logLevel = isDebugEnabled && isLocal ? Types.LogLevel.Debug : Types.LogLevel.None

let identifyObj: Identify
if (isEnabled) {
  init(amplitudeToken, '', { logLevel })
  identifyObj = new Identify()
}

const actions = {
  track: (
    eventInput: string | Types.BaseEvent,
    eventProperties = {},
    eventOptions: Types.EventOptions = {}
  ) => isEnabled && track(eventInput, eventProperties, eventOptions),
  identify: (userInfo = {}) => {
    if (isEnabled) {
      identify(identifyObj, userInfo)
    }
  },
  setInfo: (field: string, value: string) => {
    if (isEnabled && identifyObj) {
      identifyObj.setOnce(field, value)
    }
  },
  setUserProperties: (properties: Record<string, string | number>) => {
    if (isEnabled && identifyObj) {
      Object.entries(properties).forEach(([key, value]) => {
        identifyObj.set(key, value)
      })
      identify(identifyObj)
    }
  },
}

export const Amplitude = actions
